import { render } from "./PrivacyPolicy.vue?vue&type=template&id=82274e94&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=82274e94&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-82274e94"

export default script